import apiService from './apiService';

class TriggerService {
  async listTriggers() {
    return apiService.listTriggers();
  }

  async createTrigger(payload) {
    return apiService.createTrigger(payload);
  }

  async getTrigger(triggerId) {
    return apiService.getTrigger(triggerId);
  }

  async updateTrigger(triggerId, payload) {
    return apiService.updateTrigger(triggerId, payload);
  }

  async deleteTrigger(triggerId) {
    return apiService.deleteTrigger(triggerId);
  }

  async toggleTrigger(triggerId) {
    return apiService.toggleTrigger(triggerId);
  }

  async runTriggerNow(triggerId, body) {
    return apiService.runTriggerNow(triggerId, body);
  }

  async listTriggerLogs(triggerId, limit = 50) {
    return apiService.listTriggerLogs(triggerId, limit);
  }

  async clearTriggerLogs(triggerId) {
    return apiService.clearTriggerLogs(triggerId);
  }
}

const triggerService = new TriggerService();
export default triggerService;
